module.exports = __webpack_public_path__ + "img/pic_default_man.1b80cde0.png";